<section>
    <mat-card-header>
        <h3>Actualizar Operación</h3>
        <button (click)="closeDialog()" mat-icon-button style="position:absolute; right: 10px;">
            <mat-icon>close</mat-icon>
        </button>
    </mat-card-header>
    <section *ngIf="!isLoading; else loadingSection">
        <div *ngIf="factoringOperation">
            <app-invoice-operation-calculation-form
            [invoiceOperationCurrent]="factoringOperation"
            (factoringCalculationResult)="receiveInvoiceOperationCalculation($event)">
            </app-invoice-operation-calculation-form>
        </div>
        <section class="d-flex justify-content-end section-btn-actions">
            <button [disabled]="!factoringCalculateResult"
            (click)="updateInvoiceOperation()"
            class="btn-operation-update" mat-raised-button color="primary">
                Actualizar
            </button>
        </section>
    </section>
</section>
<ng-template #loadingSection>
    <section class="spinner">
        <mat-spinner diameter="80"></mat-spinner>
    </section>
</ng-template>